// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Container (Frame 176) ─────────────────────────────── */

.scl--cms-components-emptyNotification {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 20px;
  width: 100%;
  height: 100%;
}

/* ── Icon Wrapper (fi_10608904) ────────────────────────── */

.scl--cms-components-emptyNotification-iconWrapper {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ── Text Block (Frame 164) ────────────────────────────── */

.scl--cms-components-emptyNotification-textBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  gap: 6px;
  width: 325px;
}

/* ── Title ─────────────────────────────────────────────── */

.scl--cms-components-emptyNotification-title {
  font-family: var(--font-family-inter);
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #323539;
}

/* ── Description ───────────────────────────────────────── */

.scl--cms-components-emptyNotification-description {
  width: 325px;
  font-family: var(--font-family-inter);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #8A8B8F;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/notification-dsb-op/empty-notification/css/emptyNotification.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA,6DAA6D;;AAE7D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,YAAY;AACd;;AAEA,6DAA6D;;AAE7D;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX","sourcesContent":["/* ── Container (Frame 176) ─────────────────────────────── */\n\n.scl--cms-components-emptyNotification {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  gap: 20px;\n  width: 100%;\n  height: 100%;\n}\n\n/* ── Icon Wrapper (fi_10608904) ────────────────────────── */\n\n.scl--cms-components-emptyNotification-iconWrapper {\n  position: relative;\n  width: 60px;\n  height: 60px;\n  border-radius: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* ── Text Block (Frame 164) ────────────────────────────── */\n\n.scl--cms-components-emptyNotification-textBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 20px;\n  gap: 6px;\n  width: 325px;\n}\n\n/* ── Title ─────────────────────────────────────────────── */\n\n.scl--cms-components-emptyNotification-title {\n  font-family: var(--font-family-inter);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 28px;\n  text-align: center;\n  color: #323539;\n}\n\n/* ── Description ───────────────────────────────────────── */\n\n.scl--cms-components-emptyNotification-description {\n  width: 325px;\n  font-family: var(--font-family-inter);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  text-align: center;\n  color: #8A8B8F;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
